import { apiCall } from '../utils/api';
import browserCacheService from './BrowserCacheService';

/**
 * Service für Nutzer-Blockierung (Mobbing-Selbstschutz)
 */
const BlockService = {
  /**
   * Blockiert einen Nutzer (keine Chat-Anfragen, nicht mehr im Matching)
   * @param {string} userId - User-ID des zu blockierenden Nutzers
   */
  blockUser: async (userId) => {
    const result = await apiCall(`/api/v1/blocks/${userId}`, { method: 'POST' });
    // Gespeicherte Suchtreffer (bis 2 Min) zeigten die Person sonst noch einmal.
    browserCacheService.invalidateSearch();
    return result;
  },

  /**
   * Hebt eine Blockierung auf
   * @param {string} userId
   */
  unblockUser: async (userId) => {
    const result = await apiCall(`/api/v1/blocks/${userId}`, { method: 'DELETE' });
    browserCacheService.invalidateSearch();
    return result;
  },

  /**
   * Liste der selbst blockierten Nutzer
   * @returns {Promise<Array<{userId, displayName, avatar, blockedAt}>>}
   */
  getBlockedUsers: async () => {
    const response = await apiCall('/api/v1/blocks');
    return response?.data || [];
  },
};

export default BlockService;
